import { render } from "./BaseWeb.vue?vue&type=template&id=3f478ed4&scoped=true"
const script = {}

import "./BaseWeb.vue?vue&type=style&index=0&id=3f478ed4&scoped=true&lang=css"
import "./BaseWeb.vue?vue&type=style&index=1&id=3f478ed4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f478ed4"]])

export default __exports__